import React, { useState } from 'react';

import Auth from '../../auth/AuthHelper';
import {
  View,
  TextInput,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  KeyboardAvoidingView,
  Dimensions, Alert,
} from 'react-native';
import mystyles from '../../assets/styles/mystyles';

export default function ConfirmSignUpScreen({ route, navigation }) {
  const [code, setCode] = useState('');
  const username = route.params?.username ?? '';
  const [message, setMessage] = useState('Sign up successful. Check your email/SMS for the confirmation code.');
  const msg =
    Dimensions.get('window').width < 360
      ? 'Confirmed. Sign in now.'
      : 'Account confirmed. You can now sign in.';



  const handleConfirm = async () => {
    try {
      await Auth.confirmSignUp({ username, code });
      //setMessage('Account confirmed. You can now sign in.');
      setMessage(msg);
      Alert.alert('Success', msg, [
        { text: 'OK', onPress: () => navigation.navigate('SignInScreen') },
      ]);

      //navigation.navigate('SignInScreen');

    } catch (e) {
      setMessage(e.message || 'Confirmation failed');
    }
  };

  const handleResend = async () => {
    try {
      await Auth.resendCode({ username });
      setMessage('Code resent.');
    } catch (e) {
      setMessage(e.message || 'Resend failed');
    }
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={mystyles.container}
    >
      <View style={mystyles.card}>
        <Text style={mystyles.title}>Confirm your account</Text>

        <TextInput
          style={mystyles.input}
          placeholder="Confirmation code"
          value={code}
          onChangeText={setCode}
          keyboardType="number-pad"
          placeholderTextColor="#8A8A8E"
        />

        <TouchableOpacity style={mystyles.primaryBtn} onPress={handleConfirm} activeOpacity={0.8}>
          <Text style={mystyles.primaryBtnText}>Confirm</Text>
        </TouchableOpacity>

        <TouchableOpacity style={mystyles.secondaryBtn} onPress={handleResend} activeOpacity={0.8}>
          <Text style={mystyles.secondaryBtnText}>Resend code</Text>
        </TouchableOpacity>

        {!!message && <Text style={mystyles.message}>{message}</Text>}
      </View>
    </KeyboardAvoidingView>

    // <View>
    //   <TextInput placeholder="Confirmation code" value={code} onChangeText={setCode} keyboardType="number-pad" />
    //   <Button title="Confirm" onPress={handleConfirm} />
    //   <Button title="Resend code" onPress={handleResend} />
    //   {message ? <Text>{message}</Text> : null}
    // </View>
  );
}
